/**
 * Utility per la gestione degli appuntamenti
 */

/**
 * Ottiene l'etichetta in italiano per lo stato di un appuntamento
 * @param {string} status - Lo stato dell'appuntamento
 * @return {string} L'etichetta in italiano
 */
export const getStatusLabel = (status) => {
    switch (status) {
      case "booked": return "Confermato";
      case "completed": return "Completato";
      case "cancelled": return "Annullato";
      case "pending_payment": return "In attesa di pagamento";
      case "paid": return "Pagato";
      case "suggested": return "Suggerito";
      default: return status;
    }
  };
  
  /**
   * Ottiene le classi Tailwind CSS per lo stile del badge di stato
   * @param {string} status - Lo stato dell'appuntamento
   * @return {string} Le classi CSS per lo stile
   */
  export const getStatusColor = (status) => {
    const label = getStatusLabel(status);
    switch (label) {
      case "Confermato":
        return "bg-green-100 text-green-800";
      case "Completato":
        return "bg-blue-100 text-blue-800";
      case "In attesa di pagamento":
        return "bg-yellow-100 text-yellow-800";
      case "Pagato":
        return "bg-purple-100 text-purple-800";
      case "Annullato":
        return "bg-red-100 text-red-800";
      case "Suggerito":
        return "bg-indigo-100 text-indigo-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };
  
  /**
   * Controlla se un appuntamento è attivo (non cancellato o completato)
   * @param {string} status - Lo stato dell'appuntamento
   * @return {boolean} True se l'appuntamento è attivo
   */
  export const isAppointmentActive = (status) => {
    return !["cancelled", "completed"].includes(status);
  };
  
  /**
   * Controlla se un appuntamento è modificabile
   * @param {string} status - Lo stato dell'appuntamento
   * @return {boolean} True se l'appuntamento è modificabile
   */
  export const isAppointmentEditable = (status) => {
    return ["booked", "paid", "pending_payment", "suggested"].includes(status);
  };
  
  /**
   * Controlla se un appuntamento è in attesa di azione da parte del paziente
   * @param {string} status - Lo stato dell'appuntamento
   * @return {boolean} True se l'appuntamento richiede azione
   */
  export const requiresPatientAction = (status) => {
    return ["pending_payment", "suggested"].includes(status);
  };